export default "__VITE_ASSET__e418eda1__"